import React from 'react';

import { Button } from '@/components/ui/button';
import documentsToSignImage from '@/assets/images/documentsToSignImage.png';
import { Link } from 'react-router-dom';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogClose,
} from '@/components/ui/dialog';
import { getPropertyAddress } from '@/utils/properties';

const SignDocumentDialog = ({
  docAvailableToSign,
  property,
  onClose,
  ...props
}) => {
  // const createdDate = new Date(docAvailableToSign?.createdDate);
  // const hours = String(createdDate.getHours()).padStart(2, '0');
  // const minutes = String(createdDate.getMinutes()).padStart(2, '0');
  // const createdTimeText = `${hours}:${minutes}`;
  // const toSignDateOnly = new Date(createdDate);
  // toSignDateOnly.setDate(toSignDateOnly.getDate() + 25);
  //
  // const createdDateText = toSignDateOnly.toLocaleDateString('nb-NO', {
  //   weekday: 'long',
  //   day: 'numeric',
  //   month: 'long',
  // });
  return (
    <Dialog modal={false} defaultOpen {...props}>
      <DialogContent
        onInteractOutside={(e) => e.preventDefault()}
        className="flex flex-col max-w-[390px] justify-between p-6 sm:p-8 gap-3 w-full z-[1400]"
      >
        <img
          className="self-center max-w-[132px]"
          alt="document signing"
          src={documentsToSignImage}
        />
        <div className="flex justify-between items-start flex-col gap-2">
          <DialogTitle asChild>
            <h2 className="text-xl font-medium tracking-normal">
              Ny tilstandsrapport til signering
            </h2>
          </DialogTitle>
          <p className="text-sm leading-[21px] max-w-[560px] font-normal tracking-normal">
            En ny tilstandsrapport fra{' '}
            <span className="font-medium">
              {docAvailableToSign?.companyName}
            </span>{' '}
            for{' '}
            <span className="font-medium">{getPropertyAddress(property)}</span>{' '}
            er klar for å sees over og signeres.{' '}
            {/* Husk å signere innen{' '}
            {createdDateText}, kl {createdTimeText}. */}
          </p>
          <div className="flex w-full gap-2.5">
            <DialogClose className="w-full mt-2" asChild>
              <Button asChild>
                <Link to={`/dashboard/${property?.boligmappaNumber}/condition`}>
                  Til rapporten
                </Link>
              </Button>
            </DialogClose>

            <DialogClose asChild>
              <Button className="w-full mt-2 border" variant="ghost">
                Gjør senere
              </Button>
            </DialogClose>
          </div>
          <p className="text-[13px] leading-[18.2px] text-sidebar-foreground/70 font-normal tracking-normal">
            Du kan når som helst finne tilbake til denne signeringen under
            Tilstand for {getPropertyAddress(property)}.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SignDocumentDialog;
